import React, { ReactNode } from "react";
import styled from "@emotion/styled";
import { colors } from "@ui/style/colors";

interface ClickableTextProps {
	children: ReactNode;
	onClick: () => void;
}

export const ClickableText: React.FC<ClickableTextProps> = ({ children, onClick }) => (
	<StyledDiv onClick={onClick}>{children}</StyledDiv>
);

const StyledDiv = styled.div`
	color: ${colors.grey};
	cursor: pointer;

	:hover {
		color: ${colors.primary};
	}
`;
